import { connect } from "react-redux";
import Viewer from "../components/Viewer/Viewer";
import { boolFormatter, valFormatter } from "../utils/formatter";
import { announce } from "../actions/announcements";

const mapStateToProps = (state, ownProps) => {
  let templateParams;
  let page = state.research.selectedPage;
  let spec = state.app.specification;
  let pageItem = state.research.exercises.find(ex => ex.code === page);
  if (pageItem) {
    if (pageItem.category === "quiz") {
      page = pageItem.referenceExerciseCode;
    } else if (pageItem.category === "spec") {
      templateParams = {
        spec,
        val: valFormatter(spec),
        bool: boolFormatter(spec)
      };
    }
  }

  return {
    baseUrl: "/c/application/" + state.app.code,
    page,
    pageName: pageItem?.name || '',
    templateParams,
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (pageName) => {
    dispatch(announce(`${pageName} page loaded`));
  }
});

const ResearchViewer = connect(mapStateToProps, mapDispatchToProps)(Viewer);

export default ResearchViewer;
